import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AppButton, Box, Inscription, RoundDoneIcon, useResponsive } from '@common-fe/common-fe';

import routes from '@/common/routes';
import { ModalWrapper } from '@/components/wrappers';

interface Props {
  subTitle: string;
  onSetVisible: (value: boolean) => void;
}

const SuccessVerifiedModal: React.FC<Props> = ({ subTitle, onSetVisible }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const history = useHistory();

  const handleNavigateToAccountProfilePage = useCallback(() => {
    onSetVisible(false);
    history.push(routes.MANAGE_PROFILE);
  }, [history, onSetVisible]);

  const handleNavigateToHomePage = useCallback(() => {
    onSetVisible(false);
    history.push(routes.HOME);
  }, [history, onSetVisible]);

  return (
    <ModalWrapper visible onSetVisible={onSetVisible}>
      <Box pad={{ vertical: 'spacing24' }}>
        <Box align="center">
          <RoundDoneIcon />
          <Inscription margin={{ top: 'spacing12' }} size="2xl" weight={700}>
            {t('Success')}
          </Inscription>
          <Inscription
            textAlign="center"
            margin={isMobile ? { top: 'spacing12', horizontal: 'spacing8' } : { top: 'spacing12' }}
          >
            {subTitle}
          </Inscription>
        </Box>

        <Box
          direction={isMobile ? 'column-reverse' : 'row'}
          justify="center"
          gap="spacing12"
          margin={{ top: 'spacing24' }}
        >
          <AppButton
            width={isMobile ? '100%' : '210px'}
            onClick={handleNavigateToAccountProfilePage}
            buttonType="secondary"
          >
            {t('Go to Account Profile')}
          </AppButton>

          <AppButton width={isMobile ? '100%' : '210px'} onClick={handleNavigateToHomePage}>
            {t('Go to Home Dashboard')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
export default SuccessVerifiedModal;
